import { createContext } from 'react';
import type { LanguageType } from '@/types/custom-types';

export const UserLanguageContext = createContext<LanguageType | null>(null);